import React, { Component } from "react";
import { getAllowedSwitches } from "../../../../AssetTypeConfig/Reports/SwitchinspectionReport";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import _ from "lodash";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { ONR_SwitchTestsAndInspectionsReportSections } from "./ONR_SwitchTestsAndInspectionsReportSchema";
import ReportFraInfoSectionContainer from "../../../../libraries/ReportGenerator/ReportFraInfoSection";
import ReportFraConditionsMasterKey from "../../../../libraries/ReportGenerator/ReportFraConditionsMasterKey";
import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";
import { getCustomer, SUPPORTED_CUSTOMERS } from "../../../MainPage/VersionInfo";
import { cnFraMasterKey } from "../../CN/cnFraMasterKeys";

const { monthly, quarterly, semiAnnual, annual } = ONR_SwitchTestsAndInspectionsReportSections;

const semiAnnualTestCodes = ["onr_SemiAnnual_HydraulicMotorCurrentTest"];

const quarterlyTestCodes = ["onr_Quarterly_BatteryVoltageTest"];
const monthlyTestCodes = [
  "onr_Monthly_SwitchVisualInspection",
  "onr_Monthly_SwitchMachineOperation",
  "onr_Monthly_SwitchObstructionNormal",
  "onr_Monthly_SwitchObstructionReverse",
  "onr_Monthly_PointPressureTest",
];

const annualTestCodes = ["onr_Annual_SwitchMachineOperation", "onr_Annual_TransducerOccupancyDTMFOperation"];

const masterKey = [
  { key: "OK", value: "Test complete equipment in satisfactory condition." },
  { key: "A/C", value: "Adjustments made/test complete-equipment in satisfactory condition." },
  {
    key: "R/C",
    value: "Repair or replacement/test complete-equipment in satisfactory condition.",
  },
  { key: "N/A", value: "Test Not Applicable." },
];

const ReportView = (props) => {
  let { data } = props;
  const decodedData = Array.isArray(data.decodedData) ? data.decodedData : [];
  const monthlyData = decodedData.filter((t) => monthlyTestCodes.includes(t.testCode));
  const quarterlyData = decodedData.filter((t) => quarterlyTestCodes.includes(t.testCode));
  const semiAnnualData = decodedData.filter((t) => semiAnnualTestCodes.includes(t.testCode));
  const annualData = decodedData.filter((t) => annualTestCodes.includes(t.testCode));
  const formSummary = decodedData[0].summary;
  const onrSwitchAttr = {
    switchModel: formSummary.smodel || " ",
    installDate: formSummary.insDate || " ",
    buss: formSummary.buss || " ",
    battInstallDate: formSummary.battDate || " ",
  };

  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      <ReportTitleSection title="Inspection Report - Switch Tests & Inspections" {...props} fontSizeOverride={"35px"} />
      <span className="spacer"></span>
      <ReportFraInfoSectionContainer {...props} data={{ ...data, onrSwitchAttr }} />
      <ReportFraConditionsMasterKey masterKey={getCustomer() === SUPPORTED_CUSTOMERS.CN ? cnFraMasterKey : masterKey} />
      <span className="spacer"></span>

      <table className="table-bordered" style={{ fontSize: "20px" }}>
        <ReportTableSectionRenderer section={monthly} rowsData={monthlyData} />
      </table>
      <table className="table-bordered" style={{ fontSize: "20px" }}>
        <ReportTableSectionRenderer section={quarterly} rowsData={quarterlyData} />
      </table>

      <table className="table-bordered" style={{ fontSize: "20px" }}>
        <ReportTableSectionRenderer section={semiAnnual} rowsData={semiAnnualData} />
      </table>

      <table className="table-bordered" style={{ fontSize: "20px" }}>
        <ReportTableSectionRenderer section={annual} rowsData={annualData} />
      </table>
    </div>
  );
};

const ONR_SwitchTestsAndInspectionsReport = (props) => {
  const { reportData, isPreview } = props;
  if (isPreview) {
    return <ReportView data={{}} />;
  }

  let reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(reportData);
  let reportGroups = ReportGroupingUtils.filterReportsByTestCodesAndUpdateDuplicateTestCodes(reportsByDateAndUser, [
    ...quarterlyTestCodes,
    ...monthlyTestCodes,
    ...semiAnnualTestCodes,
    ...annualTestCodes,
  ]);
  let reportsWithDecodedFormData = ReportGroupingUtils.decodeTestsInReportGroups(reportGroups);

  return reportsWithDecodedFormData.map((report, i) => <ReportView key={i} {...props} data={report} />);
};

export default ONR_SwitchTestsAndInspectionsReport;



// WEBPACK FOOTER //
// ./src/components/Reports/ONR/SwitchTestsAndInspectionsReport/index.jsx